import {
  PurchaseRequestResponseDto,
  TossConfirmPaymentDto,
  TossConfirmResponseDto,
  PurchaseRequestDto,
  CancelPendingPointResponseDto,
} from '../../../constants/types/purchase-type';
import instance from '../../axios/utils.ts/instance';

/**
 * 결제 요청 api (토스페이먼츠)
 * @description 전액포인트 결제 시 즉시 완료
 * @param body
 * @returns
 */
export const purchaseRequest = async (body: PurchaseRequestDto) => {
  const response = await instance.post<PurchaseRequestResponseDto>(
    '/v1/order/master/purchase-request',
    body,
  );
  return response.data;
};

/**
 * 토스 결제 승인 api
 * @description 토스 결제창에서 결제 완료 후 반드시 호출해야 함. 이 API를 호출하지 않으면 결제가 완료되지 않음.
 * @param body
 * @returns
 */
export const confirmTossPayment = async (body: TossConfirmPaymentDto) => {
  const response = await instance.post<TossConfirmResponseDto>(
    '/v1/order/master/toss/confirm',
    body,
  );
  return response.data;
};

/**
 * 포인트 취소 api
 * @description 결제 실패 시 해당 결제건에서 사용하려고 했던 포인트 취소 요청
 * @param orderMasterId 주문 마스터 ID
 * @returns
 */
export const cancelPendingPoint = async (orderMasterId: string) => {
  const response = await instance.put<CancelPendingPointResponseDto>(
    `/v1/order/master/cancel-pending-point/${orderMasterId}`,
  );
  return response.data;
};
